import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import { DisconnectedNotificationModal } from '@user/pages/ViewModelPage/internal/DisconnectedNotificationModal';
import { useWindowActive } from '@view-model/models/common/hooks/useWindowActive';
import { useNetworkConnected } from '@view-model/models/common/hooks/useNetworkConnected';
import { usePrevious } from '@view-model/models/common/hooks/usePrevious';
const ConnectedToastId = 'connected';
const DisconnectedToastId = 'disconnected';

export const ConnectionStatusView: React.FC = () => {
  const { t } = useTranslation();
  const [showDisconnectedModal, setShowDisconnectedModal] = useState<boolean>(false);

  const windowActive = useWindowActive();
  const connected = useNetworkConnected(10);
  const prevConnected = usePrevious(connected, true);

  useEffect(() => {
    if (connected) {
      if (!prevConnected) {
        // 切断状態→接続状態になった場合のみ、接続回復の処理を行う
        toast(t('viewModel.connectionStatus.connected'), { id: ConnectedToastId });
        setShowDisconnectedModal(false);
        toast.dismiss(DisconnectedToastId);
      }
      return;
    }

    // ウィンドウがアクティブでない場合は警告メッセージを表示しない
    if (!windowActive) return;

    toast.error(t('viewModel.connectionStatus.disconnected'), {
      duration: Infinity,
      id: DisconnectedToastId,
    });
    setShowDisconnectedModal(true);
  }, [connected, prevConnected, windowActive, t]);

  const handleCloseModal = () => {
    setShowDisconnectedModal(false);
  };

  return <>{showDisconnectedModal && <DisconnectedNotificationModal onClose={handleCloseModal} />}</>;
};
